<template>
    <section class="row-12">
        <h2 class="col-6 col-sm-12">Projekty udostępnione dla Ciebie</h2>
        <div class="col-6 col-sm-12">
            <div class="row-12 m-t-2">
                <div class="col-12 col-sm-12 input-with-icon">
                    <input id="searchFilter" v-model="inputText" placeholder="Wyszukaj..."/>
                    <i class="i-search"></i>
                </div>
            </div>
        </div>

        <div class="col-12 m-t-1 m-b-5">
            <div class="row-12" v-if="filteredList.length > 0">
                <div class="card col-4 col-sm-12 col-md-6 wow fadeIn" v-for="animeCard in filteredList" :key="animeCard.id">
                    <div class="card-image">
                        <img :src="animeCard.main_image" :id="'animeCardImg-'+animeCard.id" :alt="animeCard.name">
                        <div class="side-menu">
                            <c-sidemenu
                                    :icon="'i-sm i-eye'"
                                    @click.native="showAnim(animeCard.id,animeCard.url,animeCard.name)"
                                    :links="[{name: 'Podgląd'}]"
                            />
                            <c-sidemenu
                                    :icon="'i-sm i-download'"
                                    @click.native="downloadModal(animeCard.main_image,animeCard.url,animeCard.name,animeCard.id)"
                                    :links="[{name: 'Pobierz'}]"
                            />
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row-12">
                            <div class="col-12 center-flex-a" style="justify-content: flex-end">
                                <i class="i-calendar text-primary i-md"></i>
                                <small> {{animeCard.date_add}}</small>
                            </div>
                        </div>
                        <h4 class="m-t-2">{{animeCard.name}}</h4>
                        <p v-if="animeCard.description.length > 0" >{{strip(animeCard.description)}}</p>
                        <p v-else> Ten projekt nie posiada opisu. Przejdź do edycji, aby go uzupełnić.</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-12" v-else>
                <error-notifier
                        type="info"
                        title="Brak projektów do wyświetlenia"
                        message="Nie posiadasz żadnych udostępnionych projektów"
                />
            </div>
        </div>
        <div class="modal" id="downloadModal" >
            <div class="modal-header">
                Pobieranie zawartości
            </div>
            <div class="modal-body center-flex-a">
                <button @click="downloadVideo()">Pobierz film (.mp4)</button>
                <button @click="donwloadFirstImg()">Pobierz 1 klatkę (.jpg)</button>
            </div>
            <div class="modal-action flex-align-right">
                <button class="button-free-p" @click="hideModal('#downloadModal')">Anuluj</button>
            </div>
        </div>
    </section>
</template>

<script>
    import SideMenu from '../../components/CardSideMenu'
    import Search from '../../components/Search.vue'
    import ErrorNotifier from '../../components/ErrorFullNotifier'

    export default {
        components: {
            'c-sidemenu': SideMenu,
            'c-search': Search,
            'error-notifier': ErrorNotifier
        },
        data: () => {
            return (
                {elementToDeleteId: null,
                    showAlphabetically: false,
                    downloadData:{
                        img:'',
                        video:'',
                        name:'',
                        id:''
                    },
                    showChronological: false,
                    animationList: [],
                    filteredList: [],
                    icon: {
                        type: String,
                        required: false,
                        default: ''
                    },
                    links: {
                        type: String,
                        required: false,
                        default: ''
                    },
                    location: {
                        type: String,
                        required: false,
                        default: ''
                    },
                    inputText: '',
                    pickedDate: ''
                }
            );
        },
        methods: {
            showModal(name){$(name).showModal()},
            hideModal(name){$(name).hideModal()},
            strip(html)
            {
                let tmp = document.createElement("DIV");
                tmp.innerHTML = html;
                return tmp.textContent || tmp.innerText || "";
            },
            downloadModal(img,video,name,id){
                axios.get(`animations/${id}/imgId`)
                    .then((response)=>{
                        this.downloadData ={
                            img: response.data.main_image,
                            video: response.data.url,
                            name: name,
                            id: id
                        };
                        this.showModal('#downloadModal');
                    });
            },
            donwloadFirstImg(){
                axios.get(`file/download/${this.downloadData.img}`, {responseType: 'blob'})
                    .then((response) => {
                        if (response.data) {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', this.downloadData.name + ".jpg");
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            notify.createNotifier("Pobieranie pliku .jpg rozpoczęte.", "info", 2000);
                        } else {
                            notify.createNotifier("Niestety nie można pobrać teraz zdjęcia. Spróbuj ponownie za chwilkę.", "danger", 4000);
                        }
                    })
                    .catch(() => {
                        notify.createNotifier("Niestety Twój film nie został jeszcze wyrenderowany. Prosimy spróbuj za minutę.", "danger", 4000);
                    });
                this.hideModal('#downloadModal');
            },
            downloadVideo() {
                axios.get(`file/download/${this.downloadData.video}`, {responseType: 'blob'})
                    .then((response) => {
                        if (response.data) {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', this.downloadData.name + ".mp4");
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            notify.createNotifier("Pobieranie pliku .mp4 rozpoczęte.", "info", 2000);
                        } else {
                            notify.createNotifier("Niestety Twój film nie został jeszcze wyrenderowany. Prosimy spróbuj za minutę.", "danger", 4000);
                        }
                    })
                    .catch(() => {
                        notify.createNotifier("Niestety Twój film nie został jeszcze wyrenderowany. Prosimy spróbuj za minutę.", "danger", 4000);
                    });
                this.hideModal('#downloadModal');
            },
            goToEditProject(id){
                this.$router.push('editAnimation/'+id);
            },
            showAnim(id, url, name){
                axios.get(`animations/${id}/imgId`)
                    .then((response)=>{
                        axios.get(`file/download/${response.data.url}`, {responseType: 'blob'})
                            .then((response) => {
                                if (response.data) {
                                    this.$router.push('viewAnimation/'+id);
                                } else {
                                    notify.createNotifier("Niestety Twój film nie został jeszcze wyrenderowany. Poczekaj na zakończenie zanim przejdziesz do podglądu.", "danger", 4000);
                                }
                            })
                            .catch(() => {
                                notify.createNotifier("Niestety Twój film nie został jeszcze wyrenderowany. Poczekaj na zakończenie zanim przejdziesz do podglądu.", "danger", 4000);
                            })
                    });
            },
            removeData(name){
                $(name).val('');
                this.filterDate();
            },
            deleteAnimation(id) {
                this.elementToDeleteId = id;
                this.showModal('#modalPromptForDelete');
            },
            denyDelete(){
                this.hideModal('#modalPromptForDelete');
            },
            changeFilter(type) {
                this.animationList = this.filteredList;
                this.animationList = type === 'alf' ? this.animationList.sort((a, b) => a.name.localeCompare(b.name)) : this.animationList.sort((a, b) => b.date_add.localeCompare(a.date_add));
                this.filterPractice();
                this.filterAnimation();
            },
            filterPractice() {
                this.filterAnimation(() => {
                    let input = this.inputText.toLowerCase();
                    let self = this;
                    this.filteredList = [];
                    if (input.length !== 0) {
                        this.animationList.filter(function (item) {
                            if (item.name.toLowerCase().includes(input))
                                self.filteredList.push(item)
                        })
                    } else {
                        this.filteredList = this.animationList;
                    }
                })
            },
            filterAnimation(callback) {
                'use strict';

                $(document).off('keyup', '#searchFilter');
                $(document).on('keyup', '#searchFilter', function (e) {
                    e.preventDefault();

                    $('.card').each(function () {
                        $(this).addClass('is-animated').stop().fadeOut(500);
                    });

                    setTimeout(() => {
                        if(callback) callback();
                        $('.card').each(function () {
                            $(this).removeClass('is-animated').addClass('is-animated-a').stop().fadeIn(500);
                        });
                    }, 550);
                });
            },
            filterDate() {
                let self = this;

                let dateFrom = $("#calendarPickerFrom").val();
                let dateTo = $("#calendarPickerTo").val();

                dateTo = (dateTo == "" ? null : moment(dateTo));
                dateFrom = (dateFrom == "" ? null : moment(dateFrom));

                this.filteredList = [];
                this.animationList.filter(function (item) {
                    let animationsDate = moment(item.date_add);

                    if(dateTo && dateFrom && animationsDate.isBetween(dateFrom, dateTo,null, '[]')){
                        self.filteredList.push(item);
                    }else if(dateTo && !dateFrom && animationsDate.isSameOrBefore(dateTo)){
                        self.filteredList.push(item);
                    }else if(dateFrom && !dateTo && animationsDate.isSameOrAfter(dateFrom)){
                        self.filteredList.push(item);
                    }else if(!dateFrom && !dateTo){
                        self.filteredList.push(item);
                    }

                })
            },
            showFilters() {
                if ($('.projectsNavigation div.filterOptions').hasClass('showFilter')) {
                    $('.projectsNavigation .filterOptions').removeClass('showFilter');
                } else {
                    $('.projectsNavigation .filterOptions').addClass('showFilter');
                }
            },
        },
        mounted: function () {
            let self = this;
            axios.get(`animations/shared`)
                .then((response) => {
                    this.animationList = response.data;

                    $(document).off('keyup', '#searchFilter');
                    $(document).on('keyup', '#searchFilter', this.filterPractice);

                    this.filteredList = this.animationList;

                    $('.calendarPicker').datepicker({
                        format: "yyyy-mm-dd",
                        language: 'pl-PL',
                    });

                    $(document).off('change', '.calendarPicker');
                    $(document).on('change', '.calendarPicker', function () {
                        self.filterDate();
                    });
                })
        },
    }
</script>
